/* unplugin-vue-components disabled */import { render } from "./ShopListView.vue?vue&type=template&id=6d8efc1d&scoped=true"
import script from "./ShopListView.vue?vue&type=script&lang=js"
export * from "./ShopListView.vue?vue&type=script&lang=js"

import "./ShopListView.vue?vue&type=style&index=0&id=6d8efc1d&lang=scss&scoped=true"

import exportComponent from "/root/workspace/xhzj-pc_Z77T/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d8efc1d"]])

export default __exports__